export const watch = {
  showing() {
    this.show()
  }
}
